import React from "react";
import { Route, Routes, Navigate } from "react-router";

import { CertificacionLaboral } from "../pages/Certificaciones";

import { RequiredPermission } from "../authentication/RequiredPermission";

export const RutasCertificaciones = () => {

  return (
    <Routes>

      <Route element={<RequiredPermission permission={['ROLE_ADMIN', 'ROLE_GENERAR_CERTIFICADOS']} />}>
        <Route path="/laboral" element={<CertificacionLaboral />} />
      </Route>

      <Route path='/*' element={<Navigate to="/" replace />} />

    </Routes>
  );
};
